interface Config {
  API_URL?: string;
  DOMAIN?: string;
  API_URL_DCC?: string;
  MY_CUSTOM_VAR?: string;
  ANOTHER_VAR?: string;
  [key: string]: any;
}

let config: Config = {};

export async function loadConfig(): Promise<Config> {
  // Read configuration directly from .env (REACT_APP_* variables).
  config = {
    API_URL: process.env.REACT_APP_API_URL,
    DOMAIN: process.env.REACT_APP_DOMAIN,
    API_URL_DCC: process.env.REACT_APP_URL_DCC,
    MY_CUSTOM_VAR: process.env.REACT_APP_MY_CUSTOM_VAR,
    ANOTHER_VAR: process.env.REACT_APP_ANOTHER_VAR,
  };
  return config;
}

export function getConfig(): Config {
  return config;
}

export function getConfigValue(key: string): string | undefined {
  return config[key];
}

// Initialize config on module load
loadConfig(); 